export const SSL_DOMAIN = 'sslDomain'; /* ССЛ допродаж до домену" */

export const SSL_HOSTING = 'sslHosting'; /* ССЛ допродаж до хостингу" */

export const HOSTING_SSL = 'hostingSsl';

export const SSL_GIFT_HOSTING = 'sslGiftHosting';

export const DOMAIN_SSL = 'domainSsl';

export const HOSTING_DOMAIN = 'hostingDomain';
